export class DestinationResortFilterValueConverter {
    toView(resort, searchTerm, filterStartCharCount, filterSearchFunction, country, language) {
        // array will be country with resorts
        // searchTerm matches with resorts
        // when no resorts are left in country, remove country

        if (!searchTerm || searchTerm.length < filterStartCharCount) return true;

        // if country itself matches search criteria - show all the resorts in this country
        switch (filterSearchFunction) {
            case 'startsWith':
                if (country.text.toUpperCase().startsWith(searchTerm.toUpperCase())) return true;
                return resort.text.toUpperCase().startsWith(searchTerm.toUpperCase());
                break;

            case 'includes':
            default:
                if (country.text.toUpperCase().includes(searchTerm.toUpperCase())) return true;
                return resort.text.toUpperCase().includes(searchTerm.toUpperCase());
                break;
        }

    }
}
